import { EGGSHELL_CREW, GREEN_CREW, Product, SOCKS } from '../products';

const wheatHatRecos: Product[] = [
    GREEN_CREW,
    EGGSHELL_CREW,
    SOCKS,   
];

export default wheatHatRecos;